
/**
 * Parse and handle external messages
 * Runs in context of ChatBotParser
 * 
 * @param message object
 * @param renderer renderer used to add external messages
 */
export default function parseExternal(message, renderer) {
   let blacklist = {
      "WaitingMode":                                        undefined,
     "wird gestartet":                                     undefined,
      "finished successfully":                              undefined,
      "^A1 Chatbot( hat den Chat (?:betreten|verlassen))":  'Kara$1',
   };

   switch(message.type) {
      case 'Message':
         let sysmessage = message.text;
         Object.keys(blacklist).map((re) => {
            let regex = new RegExp(re);
            if (regex.test(sysmessage)) {
               let other = blacklist[regex];
               if (!other) {
                  sysmessage = undefined;
               }
               else {
                  sysmessage = sysmessage.replace(regex, other);
               }
            }
         });
         if (sysmessage) {
            renderer.addSystemMessage(sysmessage);
         } 
         break;
      default:
            if (message.text) {
                  renderer.addSystemMessage(message.text);
            }
      break;
   }
}